import MessagesService, {
    MessageListDto,
    MessageDto,
    CreateMessageRequest,
} from '../../features/messages/services/messagesService';

interface MessagesSlice {
    messages: MessageListDto[];
    currentMessage: MessageDto | null;
    messagesLoading: boolean;
    messagesError: string | null;

    fetchMessages: () => Promise<void>;
    fetchMessage: (id: string) => Promise<void>;
    createMessage: (data: CreateMessageRequest) => Promise<MessageDto>;
    deleteMessage: (id: string) => Promise<void>;
    clearMessagesError: () => void;
    resetMessages: () => void;
}

const messagesService = new MessagesService();

const createMessagesSlice = (set: any, get: any) => ({
    messages: [],
    currentMessage: null,
    messagesLoading: false,
    messagesError: null,

    fetchMessages: async () => {
        set({ messagesLoading: true, messagesError: null });
        try {
            const messages = await messagesService.getMessages();
            set({ messages, messagesLoading: false });
        } catch (error: any) {
            const errorMessage =
                error?.response?.data?.message ||
                error?.message ||
                'Kunde inte hämta meddelanden';
            set({ messagesError: errorMessage, messagesLoading: false });
        }
    },

    fetchMessage: async (id: string) => {
        set({ messagesLoading: true, messagesError: null });
        try {
            const message = await messagesService.getMessage(id);
            set({ currentMessage: message, messagesLoading: false });
        } catch (error: any) {
            const errorMessage =
                error?.response?.data?.message ||
                error?.message ||
                'Kunde inte hämta meddelandet';
            set({ messagesError: errorMessage, messagesLoading: false });
        }
    },

    createMessage: async (data: CreateMessageRequest) => {
        set({ messagesLoading: true, messagesError: null });
        try {
            const message = await messagesService.createMessage(data);
            // Refresh messages list
            await get().fetchMessages();
            set({ messagesLoading: false });
            return message;
        } catch (error: any) {
            const errorMessage =
                error?.response?.data?.message ||
                error?.message ||
                'Kunde inte skicka meddelandet';
            set({ messagesError: errorMessage, messagesLoading: false });
            throw error;
        }
    },

    deleteMessage: async (id: string) => {
        set({ messagesLoading: true, messagesError: null });
        try {
            await messagesService.deleteMessage(id);
            // Remove from local state
            const currentMessages = get().messages;
            set({
                messages: currentMessages.filter(
                    (m: MessageListDto) => m.id !== id
                ),
                messagesLoading: false,
            });
        } catch (error: any) {
            const errorMessage =
                error?.response?.data?.message ||
                error?.message ||
                'Kunde inte ta bort meddelandet';
            set({ messagesError: errorMessage, messagesLoading: false });
            throw error;
        }
    },

    clearMessagesError: () => set({ messagesError: null }),

    resetMessages: () =>
        set({
            messages: [],
            currentMessage: null,
            messagesLoading: false,
            messagesError: null,
        }),
});

export { createMessagesSlice };
export type { MessagesSlice };
